import React from 'react';
import './SimpleSpectrumDisplay.css';

const SimpleSpectrumDisplay = ({ audioData, isPlaying }) => {
  if (!isPlaying || !audioData?.frequency) return null;

  const barCount = 32;
  const bars = [];

  for (let i = 0; i < barCount; i++) {
    const freqIndex = Math.floor((i / barCount) * audioData.frequency.length);
    const amplitude = audioData.frequency[freqIndex] || 0;
    const height = Math.max(2, amplitude * 100);
    
    // Rainbow colors across spectrum
    const hue = (i / barCount) * 360;
    const saturation = 80 + amplitude * 20;
    const lightness = 50 + amplitude * 30;
    
    bars.push(
      <div
        key={i}
        className="spectrum-bar"
        style={{
          height: `${height}%`,
          backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
          boxShadow: `0 0 ${5 + amplitude * 15}px hsl(${hue}, 100%, 70%)`,
        }}
      />
    );
  }

  return (
    <div className="simple-spectrum-display">
      <div className="spectrum-bars">
        {bars}
      </div>
    </div>
  );
};

export default SimpleSpectrumDisplay;